exports = module.exports = require("./../node_modules/.npminstall/css-loader/0.10.1/css-loader/lib/css-base.js")();
exports.push([module.id, "body,html{height:100%}:focus{outline:0}body{font-size:62.5%;font-family:'Segoe UI',Tahoma,sans-serif;margin:0;padding:0;position:relative}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/css-loader/0.10.1/css-loader?sourceMap!./~/.npminstall/less-loader/2.2.3/less-loader!./src/index.less
// module id = 2
// module chunks = 0